export default __webpack_public_path__ + "static/media/walnut.b8865f8a.webp";